var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneOncallStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40931",
    "data-name": "Group 40931",
    transform: "translate(-334 -595)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15542",
    "data-name": "Rectangle 15542",
    width: 20,
    height: 20,
    transform: "translate(334 595)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(335.266 596.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_42",
    d: "M63.875,68.107c-5.933.192-16.6-10.393-11.645-16.139l.839-.728a2.243,2.243,0,0,1,3.152.034c.021.021,1.372,1.776,1.372,1.776a2.259,2.259,0,0,1,0,3.122l-.758.9a1.008,1.008,0,0,0-.132,1.09,9.294,9.294,0,0,0,4.17,4.179.993.993,0,0,0,1.09-.132l.907-.762a2.263,2.263,0,0,1,3.122,0s1.755,1.35,1.776,1.372a2.262,2.262,0,0,1,0,3.19l-.664.762A4.509,4.509,0,0,1,63.875,68.107Z",
    transform: "translate(-50.954 -50.609)",
    fill: "#d1131d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37006",
    "data-name": "Path 37006",
    d: "M34.31.25a4.06,4.06,0,0,0-3.629,5.885l-.42,1.679a.452.452,0,0,0,.548.548l1.679-.42A4.062,4.062,0,1,0,34.31.25Zm1.547,5.416H32.763a.451.451,0,0,1,0-.9h3.095a.451.451,0,0,1,0,.9Zm0-1.805H32.763a.451.451,0,0,1,0-.9h3.095a.451.451,0,0,1,0,.9Z",
    transform: "translate(-20.903 -0.25)",
    fill: "#d1131d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOncallStatus);
export default __webpack_public_path__ + "static/media/phone-oncall-status.b019b65e797102806cdd9c785d1b0741.svg";
export { ForwardRef as ReactComponent };